import OfficesContainer from './OfficesContainer';
export default OfficesContainer;
